
  var _styles = {
  "cfe-modal-container": {
    "display": "flex",
    "flexDirection": "column",
    "backgroundColor": "rgb(255,255,255)",
    "flex": 1,
    "height": "13.33333rem"
  },
  "cfe-scroll-wrap": {
    "display": "flex",
    "flexDirection": "row",
    "flex": 1,
    "position": "relative",
    "height": "100%"
  },
  "cfe-scroll-view": {
    "flex": 1
  },
  "cfe-all-nation-item": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "cfe-all-nation-text": {
    "fontSize": "0.37333rem",
    "lineHeight": "0.53333rem",
    "color": "rgb(34,34,34)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "marginTop": "0.32rem",
    "marginBottom": "0.32rem",
    "marginLeft": "0.53333rem"
  },
  "cfe-five-city-container": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "10rem",
    "position": "relative"
  },
  "cfe-five-city-vap-petal": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "zIndex": 0
  },
  "cfe-five-city-vap-free-order": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "zIndex": 1,
    "pointerEvents": "none"
  },
  "cfe-five-city-header-img": {
    "width": "10rem",
    "height": "1.50667rem",
    "marginBottom": "0.77333rem",
    "position": "relative",
    "zIndex": 2
  },
  "cfe-five-city-content-wrapper": {
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "position": "relative",
    "zIndex": 2
  },
  "cfe-five-city-fir-line": {
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "width": "10rem",
    "justifyContent": "space-between",
    "marginBottom": "0.64rem",
    "paddingTop": 0,
    "paddingRight": "1.16rem",
    "paddingBottom": 0,
    "paddingLeft": "1.16rem"
  },
  "cfe-five-city-sec-line": {
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "width": "10rem",
    "justifyContent": "space-between",
    "paddingTop": 0,
    "paddingRight": "2.46667rem",
    "paddingBottom": 0,
    "paddingLeft": "2.46667rem",
    "marginBottom": "0.93333rem"
  },
  "cfe-five-city-item": {
    "width": "2.18667rem",
    "height": "2.93333rem",
    "display": "flex",
    "position": "relative",
    "overflow": "visible"
  },
  "cfe-five-city-two-button-wrapper": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "width": "10rem",
    "paddingTop": 0,
    "paddingRight": "1.97333rem",
    "paddingBottom": 0,
    "paddingLeft": "1.97333rem",
    "position": "relative",
    "zIndex": 2
  },
  "cfe-five-city-search-button": {
    "width": "2.90667rem",
    "height": "1.06667rem",
    "borderRadius": "7.45333rem",
    "backgroundColor": "rgba(0,0,0,0)",
    "borderWidth": "0.02667rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,255,255)",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "cfe-five-city-search-button-text": {
    "fontSize": "0.4rem",
    "fontWeight": "600",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC"
  },
  "cfe-five-city-change-button": {
    "width": "2.90667rem",
    "height": "1.06667rem",
    "borderRadius": "7.45333rem",
    "backgroundColor": "rgb(255,237,75)",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "cfe-five-city-change-button-text": {
    "fontSize": "0.4rem",
    "fontWeight": "600",
    "color": "rgb(0,0,0)",
    "fontFamily": "PingFang SC"
  },
  "cfe-five-city-one-button-wrapper": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "position": "relative",
    "zIndex": 2
  },
  "cfe-five-city-bigger-search-button": {
    "width": "4.93333rem",
    "height": "1.06667rem",
    "borderRadius": "7.45333rem",
    "borderWidth": "0.02667rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,255,255)",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "cfe-five-city-bigger-search-button-text": {
    "fontSize": "0.4rem",
    "fontWeight": "600",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC"
  },
  "cfe-five-city-close-button-wrapper": {
    "display": "flex",
    "flexDirection": "row",
    "width": "100%",
    "justifyContent": "center",
    "alignItems": "center",
    "position": "relative",
    "zIndex": 2
  },
  "cfe-five-city-close-button": {
    "marginTop": "0.82667rem",
    "position": "relative",
    "zIndex": 2
  },
  "cfe-five-city-close-button-img": {
    "width": "0.64rem",
    "height": "0.64rem"
  }
};



  module.exports = _styles;
  